<template>
    <form class="md:w-[400px] lg:mx-0 mx-[10px]" @submit.prevent="submitForm">
        <FormInput label="Vaše e-mailová adresa" v-model="email" name="email" type="email" required />

        <button
            :disabled="showSuccessMessage"
            class="flex items-center md:w-[400px] justify-center w-full px-8 py-4 mt-4 text-white rounded-full group hover:opacity-80 text-button bg-brand-blue"
            type="submit"
          >
            Zaslat přihlašovací e-mail
            <svg
              class="ml-4 transition-all duration-200 transform group-hover:translate-x-1"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M17.2421 5.99219C17.0929 5.99222 16.947 6.03679 16.8232 6.12019C16.6994 6.20358 16.6033 6.32202 16.5472 6.46033C16.4911 6.59865 16.4776 6.75056 16.5083 6.89662C16.539 7.04269 16.6126 7.17627 16.7197 7.28027L20.4394 11H1.74994C1.65056 10.9986 1.55188 11.017 1.45966 11.054C1.36743 11.0911 1.28349 11.1461 1.21271 11.2159C1.14194 11.2857 1.08573 11.3688 1.04737 11.4605C1.00901 11.5522 0.989258 11.6506 0.989258 11.75C0.989258 11.8494 1.00901 11.9478 1.04737 12.0395C1.08573 12.1312 1.14194 12.2143 1.21271 12.2841C1.28349 12.3539 1.36743 12.4089 1.45966 12.446C1.55188 12.483 1.65056 12.5014 1.74994 12.5H20.4394L16.7197 16.2197C16.6477 16.2888 16.5902 16.3716 16.5506 16.4632C16.511 16.5548 16.4901 16.6534 16.4891 16.7532C16.4881 16.8529 16.507 16.9519 16.5447 17.0443C16.5824 17.1367 16.6382 17.2206 16.7088 17.2912C16.7793 17.3617 16.8633 17.4175 16.9556 17.4552C17.048 17.4929 17.147 17.5118 17.2468 17.5108C17.3466 17.5098 17.4451 17.4889 17.5367 17.4493C17.6283 17.4097 17.7111 17.3523 17.7802 17.2803L22.7802 12.2803C22.9208 12.1396 22.9998 11.9489 22.9998 11.75C22.9998 11.5511 22.9208 11.3604 22.7802 11.2197L17.7802 6.21973C17.7103 6.14773 17.6267 6.0905 17.5342 6.05142C17.4418 6.01233 17.3425 5.99219 17.2421 5.99219Z"
                fill="white"
              />
            </svg>
          </button>

        <div class="mt-3 text-brand-gray-900">
          <span class="mr-2">Nemáte účet?</span><a class="text-brand-blue hover:opacity-80 hover:underline" :href="route('frontend.registration')">Zaregistrujte se.</a>
        </div>

    </form>

    <div v-if="errorMessage !== null" class="p-4 mt-2  md:w-[400px] w-full rounded-md bg-brand-red">
      <div class="flex items-center">
        <div class="shrink-0">
          <ExclamationIcon class="w-5 h-5 text-white" aria-hidden="true" />
        </div>
        <div class="ml-3">
          <p class="text-sm font-semibold text-white text-body">
            {{ errorMessage }}
          </p>
        </div>
        <div class="pl-3 ml-auto">
          <div class="-mx-1.5 -my-1.5">
            <button
              @click="errorMessage = null"
              type="button"
              class="inline-flex bg-white rounded-md p-1.5 text-brand-red focus:outline-none"
            >
              <span class="sr-only">Dismiss</span>
              <XIcon class="w-5 h-5" aria-hidden="true" />
            </button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="showSuccessMessage" class="p-4 mt-4 rounded-md md:w-[400px] w-full bg-brand-green">
      <div class="flex items-center">
        <div class="shrink-0">
          <CheckCircleIcon class="w-5 h-5 text-white" aria-hidden="true" />
        </div>
        <div class="ml-3">
          <p class="text-sm font-semibold text-white text-body">
            Na zadaný e-mail jsme vám zaslali přihlašovací odkaz, pokud jste se na něj registrovali.
          </p>
        </div>
        <div class="pl-3 ml-auto">
          <div class="-mx-1.5 -my-1.5">
            <button
              @click="showSuccessMessage = false"
              type="button"
              class="
                inline-flex
                bg-white
                rounded-md
                p-1.5
                text-brand-green
                focus:outline-none
              "
            >
              <span class="sr-only">Dismiss</span>
              <XIcon class="w-5 h-5" aria-hidden="true" />
            </button>
          </div>
        </div>
      </div>
    </div>
</template>

<script>

import { ref } from 'vue';

import FormInput from "../Atomic/Input.vue";
import axios from "axios";
import { ExclamationIcon, XIcon, CheckCircleIcon } from "@heroicons/vue/solid";
import { useReCaptcha } from 'vue-recaptcha-v3';

export default {

    components: {
        FormInput,
        ExclamationIcon,
        XIcon,
        CheckCircleIcon
    },

    setup() {

      const { executeRecaptcha, recaptchaLoaded } = useReCaptcha()

      const email = ref('');
      const errorMessage = ref(null);
      const showSuccessMessage = ref(false);

      const submitForm = async () => {
        errorMessage.value = null;

        await recaptchaLoaded();
        const token = await executeRecaptcha();

        try {
            await axios.post(route("user.send-login-link"), {
              email: email.value,
              recaptcha_token: token
            });
            showSuccessMessage.value = true;
        } catch (err) {
            if (err.response.status === 423) {
              errorMessage.value = "Zatím nelze odeslat přihlašovací e-mail znovu, počkejte prosím.";
            } else {
              errorMessage.value = "Nepodařilo se odeslat přihlašovací e-mail.";
            }
        }
      }

      return {
        email,
        errorMessage,
        showSuccessMessage,
        submitForm
      }
    }
}
</script>

<style>
</style>
